import { useEffect, useMemo, useState } from 'react';

export function useMicCapability() {
    const [hasDevice, setHasDevice] = useState(false);
    const [perm, setPerm] = useState('unknown'); // 'granted' | 'denied' | 'prompt' | 'unknown'

    const refreshDevices = async () => {
    try {
        if (!navigator.mediaDevices?.enumerateDevices) return setHasDevice(false);
            const list = await navigator.mediaDevices.enumerateDevices();
            setHasDevice(list.some((d) => d.kind === 'audioinput'));
        } catch {
            setHasDevice(false);1
        }
    };

    const refreshPermission = async () => {
        try {
            if (!navigator.permissions?.query) return setPerm('unknown'); // Safari
            // @ts-ignore – microphone is valid in browsers that support it
            const status = await navigator.permissions.query({ name: 'microphone' });
            setPerm(status.state); // 'granted' | 'denied' | 'prompt'
            // keep up to date
            status.onchange = () => setPerm(status.state);
        } catch {
            setPerm('unknown');
        }
    };

    useEffect(() => {
        refreshDevices();
        refreshPermission();
        const onChange = () => refreshDevices();
        navigator.mediaDevices?.addEventListener?.('devicechange', onChange);
        return () => navigator.mediaDevices?.removeEventListener?.('devicechange', onChange);
    }, []);

    const state = useMemo(() => {
        // A few useful buckets for UI logic
        if (!hasDevice) return 'no-device';
        if (perm === 'denied') return 'blocked';
        if (perm === 'granted') return 'ready';
        if (perm === 'prompt' || perm === 'unknown') return 'needs-prompt';
        return 'needs-prompt';
    }, [hasDevice, perm]);

    return { state, hasDevice, perm, refreshDevices, refreshPermission };
}